import React, { FC } from 'react';
import './NotificationSkeleton.scss';

export const NotificationSkeleton: FC = () => {
  return (
    <div className="notification-skeleton notification">
      <div className="notification-skeleton__header skeleton" />
      <div className="notification-skeleton__info">
        <div className="notification-skeleton__info__title skeleton" />
        <div className="notification-skeleton__info__message skeleton" />
      </div>
    </div>
  );
};
